
import {
    defineComponent,
    ref
} from "vue";
import {
    ActionTypes,
    useStore
} from './store';

export default defineComponent({
    setup() {
        const store = useStore();
        store.dispatch(ActionTypes.LOAD_PROJECTS, undefined);
        const state = ref(store.state);

        return {
            state
        };
    }
});
